import React from "react";
import { Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import SVG_Svg, { G as SVG_G, Path as SVG_Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent(SVG_Path);
const G = Animated.createAnimatedComponent(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"> <desc id="IMP.BLUE">{"#SearchIcon":{"type":"SELECTOR","constraint":"xMinYMin meet","width":20.000001907348633,"height":20.000001907348633},"#Vector":{"type":"SELECTOR","constraint":"none","width":20.000001907348633,"height":20.000001907348633}}</desc>
 * <g id="SearchIcon">
 * <rect width="20" height="20" fill="white" fill-opacity="0.01"/>
 * <g id="Vector">
 * <path d="M7.27906 15.1002C3.27558 15.1002 0 11.7026 0 7.55008C0 3.39753 3.27558 0 7.27906 0C11.2825 0 14.5581 3.39753 14.5581 7.55008C14.5581 11.7026 11.2825 15.1002 7.27906 15.1002ZM7.27906 1.25835C3.88217 1.25835 1.21318 4.02671 1.21318 7.55008C1.21318 11.0734 3.88217 13.8418 7.27906 13.8418C10.676 13.8418 13.3449 11.0734 13.3449 7.55008C13.3449 4.02671 10.5546 1.25835 7.27906 1.25835Z" fill="#373938"/>
 * <path d="M12.2518 11.6417L11.428 12.5655L19.1761 20L20 19.0762L12.2518 11.6417Z" fill="#373938"/>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#SearchIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 20.000001907348633,
 * 		"height": 20.000001907348633
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 20.000001907348633,
 * 		"height": 20.000001907348633
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const SearchIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 20,
      height: 20,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          {...props}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 20 20"
        >
          <G id="SearchIcon">
            <Path
              fill="white"
              fillOpacity={0.01}
              id="SearchIcon_elem0"
              d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
            <Svg preserveAspectRatio="none" viewBox="0 0 20 20">
              <G id="Vector">
                <Path
                  d="M7.27906 15.1002C3.27558 15.1002 0 11.7026 0 7.55008C0 3.39753 3.27558 0 7.27906 0C11.2825 0 14.5581 3.39753 14.5581 7.55008C14.5581 11.7026 11.2825 15.1002 7.27906 15.1002ZM7.27906 1.25835C3.88217 1.25835 1.21318 4.02671 1.21318 7.55008C1.21318 11.0734 3.88217 13.8418 7.27906 13.8418C10.676 13.8418 13.3449 11.0734 13.3449 7.55008C13.3449 4.02671 10.5546 1.25835 7.27906 1.25835Z"
                  fill="#373938"
                  id="Vector_elem0"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  d="M12.2518 11.6417L11.428 12.5655L19.1761 20L20 19.0762L12.2518 11.6417Z"
                  fill="#373938"
                  id="Vector_elem1"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          fill="white"
          fillOpacity={0.01}
          id="SearchIcon_elem0"
          d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="Vector">
          <Path
            d="M7.27906 15.1002C3.27558 15.1002 0 11.7026 0 7.55008C0 3.39753 3.27558 0 7.27906 0C11.2825 0 14.5581 3.39753 14.5581 7.55008C14.5581 11.7026 11.2825 15.1002 7.27906 15.1002ZM7.27906 1.25835C3.88217 1.25835 1.21318 4.02671 1.21318 7.55008C1.21318 11.0734 3.88217 13.8418 7.27906 13.8418C10.676 13.8418 13.3449 11.0734 13.3449 7.55008C13.3449 4.02671 10.5546 1.25835 7.27906 1.25835Z"
            fill="#373938"
            id="Vector_elem0"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            d="M12.2518 11.6417L11.428 12.5655L19.1761 20L20 19.0762L12.2518 11.6417Z"
            fill="#373938"
            id="Vector_elem1"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </G>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(SearchIcon);
